import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { observer } from 'mobx-react';
import { ExperienceResource } from '../../Types';

export interface Props {
  resource: ExperienceResource;
}

const Description: React.FC<Props> = ({ resource }) =>
  ReactHtmlParser(resource.payload.publicDetailedDescriptionHtml);

export default observer(Description);
